(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-text-row"] && !Shopify.designMode) return;
  try {
    
(function () {
  function enhance(slider) {
    if (slider.dataset.mobileArrowsAttached === '1') return;
    slider.dataset.mobileArrowsAttached = '1';

    var host = slider.parentElement;
    if (!host) return;
    host.classList.add('text-row-mobile-slider-host');

    var arrows = document.createElement('div');
    arrows.className = 'text-row-mobile-arrows';
    arrows.innerHTML =
      '<button type="button" class="text-row-mobile-arrow text-row-mobile-arrow--prev" aria-label="Previous">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<button type="button" class="text-row-mobile-arrow text-row-mobile-arrow--next" aria-label="Next">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>' +
      '</button>';
    host.appendChild(arrows);

    var prev = arrows.querySelector('.text-row-mobile-arrow--prev');
    var next = arrows.querySelector('.text-row-mobile-arrow--next');

    function scrollOne(direction) {
      var item = slider.querySelector('.grid-item');
      if (!item) return;
      var step = item.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
      slider.scrollBy({ left: direction * (step + gap), behavior: 'smooth' });
    }

    function updateDisabled() {
      var max = slider.scrollWidth - slider.clientWidth - 2;
      prev.disabled = slider.scrollLeft <= 1;
      next.disabled = slider.scrollLeft >= max;
    }

    prev.addEventListener('click', function () { scrollOne(-1); });
    next.addEventListener('click', function () { scrollOne(1); });
    slider.addEventListener('scroll', updateDisabled, { passive: true });
    window.addEventListener('resize', updateDisabled);
    updateDisabled();
  }

  function init() {
    document.querySelectorAll('[data-section-type="columns"] .grid--mobile-slider').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
